__turbopack_context__.v({
  "btn__close": "oFaqGa_btn__close",
  "my_list_query_param_popup": "oFaqGa_my_list_query_param_popup",
});
